import axios from 'axios';

/**
 * Redirects user when a menu option from the nav select has been pressed.
 */
export const initAccountMobileMenu = (): void => {
  const accountMenu = document.querySelector('[data-select-as-nav]');
  if (!accountMenu) return;

  accountMenu.addEventListener('change', function (e) {
    const zeAccountMenu = <HTMLSelectElement>e.target;
    const dataset = zeAccountMenu.options[zeAccountMenu.selectedIndex].dataset;
    if (dataset.changePassword) {
      axios.get('/account/logout')
        .then(() => window.location.href = '/account/login/#recover')
        .catch((e) => console.error(e));
    } else {
      window.location.pathname = dataset.url;
    }
  });
}